import { h } from "preact";
import { css } from "emotion";
import IconLeft from "../assets/images/IconLeft";
import IconRight from "../assets/images/IconRight";
import iconSeeMore from "../assets/images/see-more.svg";
import iconLeft from "../assets/images/icon-arrow-left.svg";
import iconRight from "../assets/images/icon-arrow-right.svg";

const buttonRepeat = [-5, -4, -3, -2, -1, 0, 1, 2, 3, 4];
const styles = {
  button: css`
    width: 28px;
    height: 28px;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    background-color: #fff;
    margin-left: 3px;
    margin-right: 3px;
    font-size: 12px !important;
    text-align: center;
    vertical-align: middle;
  `,
  iconButton: css`
    width: 28px;
    height: 28px;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    background-color: #fff;
    display: flex;
    justify-content: center;
    padding: 1px;
  `,
  ellipsisButton: css`
    width: 28px;
    height: 28px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    padding: 1px;
    position: relative;
    img:last-child {
      display: none;
    }
    &:hover {
      img:last-child {
        display: block;
      }
      img:first-child {
        display: none;
      }
    }
  `,
  ellipsis: css`
    top: -2px;
    left: 4px;
    font-size: 15px;
    font-weight: 900;
    position: absolute;
    letter-spacing: 3px;
    color: #cccccc;
  `,
  leftArrow: css`
    &hover: {
    }
  `
};
// create pagination button
const Button = props => {
  const {
    currentPage,
    selectPagination,
    index,
    value,
    lastPage,
    customStyles
  } = props;
  const step = currentPage + value;
  const prevCheck = () => {
    const checkDiff = lastPage - currentPage;
    // if checkDiff < 4, shows total 5 buttons (prev + current + next)
    if (checkDiff < 4) {
      return checkDiff < index && step > 1;
    }
    // if currentPage > 4, only shows first 2 prev buttons
    if (currentPage > 4 && value < -2) {
      return false;
    }
    return currentPage > -value && currentPage + value !== 1;
  };
  const nextCheck = () => {
    // if currentPage < 5, shows total 5 buttons (prev + current + next)
    if (currentPage < 5) {
      return currentPage + value < 6 && step < lastPage;
    }
    // if currentPage > 4, only shows first 2 next buttons
    if (currentPage > 4 && value > 2) {
      return false;
    }
    return (
      currentPage < lastPage - (value - 1) && currentPage + value !== lastPage
    );
  };
  let conditionCheck = value === 0 ? true : false;
  conditionCheck = value < 0 ? prevCheck() : conditionCheck;
  conditionCheck = value > 0 ? nextCheck() : conditionCheck;

  if (!conditionCheck) {
    return null;
  }
  if (value === 0) {
    return (
      <button className={`${styles.button} ${customStyles.selectedButton}`}>
        {currentPage}
      </button>
    );
  }
  return (
    <button
      className={styles.button}
      onClick={step === 0 ? null : () => selectPagination(step)}
    >
      {step}
    </button>
  );
};

/**
 * Display pagination
 *
 * @param {*} props
 * @returns
 */
const Pagination = props => {
  const {
    totalSize = 0,
    currentPage,
    selectPagination,
    position = "right",
    resultsPerPage = 12,
    theme = null
  } = props;
  const previousOne = currentPage > 1;
  const lastPage = Math.ceil(totalSize / resultsPerPage);
  const nextOne = currentPage < lastPage;
  const selectEllipsis = isNext => {
    if (isNext) {
      const returnPage =
        currentPage + 4 > lastPage ? lastPage : currentPage + 4;
      selectPagination(returnPage);
    } else {
      const returnPage = currentPage - 4 < 1 ? 1 : currentPage - 4;
      selectPagination(returnPage);
    }
  };
  let justifyContent = "flex-end";
  if (position === "left") {
    justifyContent = "flex-start";
  } else if (position === "center") {
    justifyContent = "center";
  }
  const wrapper = css`
    display: flex;
    justify-content: ${justifyContent};
    margin-top: 32px;
    @media (max-width: 600px) {
      justify-content: center;
    }
  `;
  const customStyles = {
    selectedButton: css`
      border: solid 1px
        ${theme && theme.primaryColor ? theme.primaryColor : "#6621c0"} !important;
      background-color: ${theme && theme.primaryColor
        ? theme.primaryColor
        : "#6621c0"} !important;
      color: ${theme && theme.primaryTextColor
        ? theme.primaryTextColor
        : "#fff"} !important;
    `
  };
  const hidePagination = resultsPerPage >= totalSize;

  if (hidePagination) {
    return null;
  }
  return (
    <div className={wrapper}>
      <button
        className={styles.iconButton}
        style={{ marginRight: 3 }}
        onClick={() => selectPagination(currentPage - 1)}
        disabled={!previousOne}
      >
        <IconLeft color={previousOne ? "#323232" : "#dedede"} />
      </button>
      {currentPage !== 1 ? (
        <button className={styles.button} onClick={() => selectPagination(1)}>
          1
        </button>
      ) : null}
      {currentPage > 4 ? (
        <button
          className={styles.ellipsisButton}
          style={{ marginRight: 3 }}
          onClick={() => selectEllipsis(false)}
        >
          <img src={iconSeeMore} />
          <img src={iconLeft} />
        </button>
      ) : null}

      {buttonRepeat.map((value, index) => {
        return (
          <Button
            currentPage={currentPage}
            selectPagination={selectPagination}
            index={index}
            value={value}
            lastPage={lastPage}
            customStyles={customStyles}
          />
        );
      })}

      {lastPage - currentPage > 3 ? (
        <button
          className={styles.ellipsisButton}
          style={{ marginRight: 3 }}
          onClick={() => selectEllipsis(true)}
        >
          <img src={iconSeeMore} />
          <img src={iconRight} />
        </button>
      ) : null}
      {currentPage !== lastPage ? (
        <button
          className={styles.button}
          onClick={() => selectPagination(lastPage)}
        >
          {lastPage}
        </button>
      ) : null}
      <button
        className={styles.iconButton}
        style={{ marginLeft: 3 }}
        onClick={() => selectPagination(currentPage + 1)}
        disabled={!nextOne}
      >
        <IconRight color={nextOne ? "#323232" : "#dedede"} />
      </button>
    </div>
  );
};
export default Pagination;



// WEBPACK FOOTER //
// ./components/Pagination.js